const d = (pt, en, es) => ({ pt, en, es });

export const CATEGORIES = [
  { id: "petiscos" },
  { id: "moquecas" },
  { id: "pratos" },
  { id: "drinks" },
  { id: "bebidas" },
  { id: "extras" },
];

export const MENU = {
  petiscos: [
    {
      group: "porcoes",
      items: [
        { name: "Fritas", desc: null, price: "R$ 60", tags: ["share"] },
        { name: "Fritas com Queijo", desc: null, price: "R$ 65", tags: ["share"] },
        { name: "Calabresa Acebolada", desc: null, price: "R$ 80", tags: [] },
        { name: "Mandioca", desc: null, price: "R$ 60", tags: [] },
        { name: "Mandioca com Queijo", desc: null, price: "R$ 65", tags: [] },
        { name: "Bife Acebolado", desc: null, price: "R$ 125", tags: [] },
        { name: "Frango à Passarinho", desc: d("Em tirinhas crocantes.", "Crispy strips.", "En tiras crocantes."), price: "R$ 80", tags: [] },
        { name: "Queijo", desc: null, price: "R$ 45", tags: [] },
        { name: "Bolinho de Bacalhau", desc: null, price: "R$ 80", tags: [] },
        { name: "Anel de Cebola", desc: null, price: "R$ 65", tags: [] },
        { name: "Batata Rústica", desc: null, price: "R$ 65", tags: [] },
        { name: "Camarão Empanado", desc: d("Com catupiry — 8 unidades.", "With catupiry cheese — 8 units.", "Con catupiry — 8 unidades."), price: "R$ 165", tags: ["share"] },
      ],
    },
    {
      group: "adore",
      items: [
        { name: "Peixe Misto", desc: d("Bagre, betara ou corvina.", "Catfish, betara or croaker.", "Bagre, betara o corvina."), price: "R$ 115", tags: [] },
        { name: "Espada", desc: null, price: "R$ 115", tags: [] },
        { name: "Pescada", desc: null, price: "R$ 120", tags: [] },
        { name: "Sororoca", desc: null, price: "R$ 120", tags: [] },
        { name: "Porquinho", desc: null, price: "R$ 115", tags: [] },
        { name: "Lula", desc: null, price: "R$ 130", tags: [] },
        { name: "Camarão 7 Barbas", desc: null, price: "R$ 115", tags: [] },
        { name: "Camarão Branco", desc: null, price: "R$ 180", tags: [] },
      ],
    },
  ],
  moquecas: [
    {
      group: "moquecas",
      note: "moquecas",
      items: [
        { name: "Moqueca Rainha do Mar", desc: d("Cação, lula, camarão rosa médio e polvo ou marisco.", "Dogfish, squid, medium pink shrimp and octopus or shellfish.", "Cazón, calamar, camarón rosa mediano y pulpo o mariscos."), price: "R$ 375", tags: ["house", "share"] },
        { name: "Mista", desc: d("Cação e camarão rosa médio.", "Dogfish and medium pink shrimp.", "Cazón y camarón rosa mediano."), price: "R$ 310", tags: ["share"] },
        { name: "Pescada", desc: null, price: "R$ 268", tags: [] },
        { name: "Vermelho", desc: null, price: "R$ 310", tags: [] },
        { name: "Robalo", desc: null, price: "R$ 310", tags: [] },
        { name: "Sororoca", desc: null, price: "R$ 268", tags: [] },
        { name: "Cação", desc: null, price: "R$ 268", tags: [] },
        { name: "Camarão Branco", desc: null, price: "R$ 300", tags: [] },
      ],
    },
  ],
  pratos: [
    {
      group: "grelhados",
      note: "grelhados",
      items: [
        { name: "Pescada", desc: null, price: "R$ 265", tags: [] },
        { name: "Vermelho", desc: null, price: "R$ 310", tags: [] },
        { name: "Robalo", desc: null, price: "R$ 310", tags: [] },
        { name: "Sororoca", desc: null, price: "R$ 265", tags: [] },
        { name: "Camarão Branco", desc: null, price: "R$ 300", tags: [] },
      ],
    },
    {
      group: "combinados",
      note: "combinados",
      items: [
        { name: "Pescada Rainha do Mar", desc: d("Filé de peixe grelhado, arroz branco, farofa de banana, molho de alcaparras e 6 unidades de camarão médio.", "Grilled fish fillet, white rice, banana farofa, caper sauce and 6 medium shrimp.", "Filete de pescado a la parrilla, arroz blanco, farofa de plátano, salsa de alcaparras y 6 camarones medianos."), price: "R$ 315", tags: ["house"] },
        { name: "Pescada ao Molho de Camarão", desc: d("Filé de peixe grelhado, molho de camarão, arroz branco, legumes e palmito puxado na manteiga.", "Grilled fish fillet, shrimp sauce, white rice, vegetables and palm hearts sautéed in butter.", "Filete de pescado a la parrilla, salsa de camarón, arroz blanco, verduras y palmito salteado en mantequilla."), price: "R$ 315", tags: [] },
        { name: "Peixe à Brasileira", desc: d("Peixe da época em filé à dorê, arroz branco, feijão e batata frita.", "Seasonal fish à dorê fillet, white rice, beans and fries.", "Pescado de temporada en filete à dorê, arroz blanco, frijoles y papas fritas."), price: "R$ 310", tags: [] },
        { name: "Barca do Rei", desc: d("Filé de peixe grelhado (sororoca) com molho especial de lula. Acompanha arroz e salada mista com palmito e manga ou batatas fritas.", "Grilled sororoca fish fillet with special squid sauce. Served with rice and mixed salad with hearts of palm and mango, or fries.", "Filete de pescado a la parrilla (sororoca) con salsa especial de calamar. Acompañado de arroz y ensalada mixta con palmito y mango, o papas fritas."), price: "R$ 318", tags: [] },
      ],
    },
    {
      group: "vinagrete",
      note: "vinagrete",
      items: [
        { name: "Lula", desc: null, price: "R$ 160", tags: [] },
        { name: "Camarão 7 Barbas com Casca", desc: null, price: "R$ 130", tags: [] },
        { name: "Camarão Branco sem Casca (Paulista)", desc: null, price: "R$ 190", tags: [] },
        { name: "Pescada", desc: null, price: "R$ 140", tags: [] },
        { name: "Sororoca", desc: null, price: "R$ 140", tags: [] },
        { name: "Marisco à Vinagrete", desc: null, price: "R$ 120", tags: [] },
        { name: "Polvo à Vinagrete", desc: null, price: "R$ 170", tags: [] },
        { name: "Palmito à Vinagrete", desc: null, price: "R$ 80", tags: [] },
      ],
    },
  ],
  drinks: [
    {
      group: "caipirinhas",
      items: [
        { name: "Caipirinha de Pinga", desc: null, price: "R$ 30", tags: [] },
        { name: "Caipirinha de Vodka Smirnoff", desc: null, price: "R$ 34", tags: [] },
        { name: "Caipirinha de Saquê", desc: null, price: "R$ 32", tags: [] },
        { name: "Caipirinha de Absolut", desc: null, price: "R$ 40", tags: [] },
        { name: "Caipirinha 2 Sabores", desc: d("Vodka ou pinga, com duas frutas à escolha.", "Vodka or cachaça, with two fruits of your choice.", "Vodka o pinga, con dos frutas a elegir."), price: "R$ 40", tags: [] },
        { name: "Folha de Mexerica (Pinga)", desc: null, price: "R$ 34", tags: [] },
        { name: "Folha de Mexerica (Vodka Smirnoff)", desc: null, price: "R$ 38", tags: [] },
        { name: "Folha de Mexerica (Saquê)", desc: null, price: "R$ 35", tags: [] },
        { name: "Folha de Mexerica (Absolut)", desc: null, price: "R$ 44", tags: [] },
      ],
    },
    {
      group: "batidas",
      items: [
        { name: "Batida Rainha do Mar", desc: d("Abacaxi, coco, morango e leite condensado.", "Pineapple, coconut, strawberry and condensed milk.", "Piña, coco, fresa y leche condensada."), price: "R$ 40", tags: ["house"] },
        { name: "Batida 7 Fontes", desc: d("Abacaxi, coco e leite condensado.", "Pineapple, coconut and condensed milk.", "Piña, coco y leche condensada."), price: "R$ 40", tags: [] },
        { name: "Batida de Coco", desc: null, price: "R$ 40", tags: [] },
        { name: "Batida de Banana", desc: null, price: "R$ 40", tags: [] },
        { name: "Mousse de Limão", desc: d("Mousse e leite condensado.", "Lime mousse and condensed milk.", "Mousse de lima y leche condensada."), price: "R$ 40", tags: [] },
        { name: "Batida da Dri", desc: d("Morango, coco, malibu e leite condensado.", "Strawberry, coconut, Malibu and condensed milk.", "Fresa, coco, Malibú y leche condensada."), price: "R$ 40", tags: [] },
        { name: "Espanhola", desc: d("Abacaxi, vinho e leite condensado.", "Pineapple, wine and condensed milk.", "Piña, vino y leche condensada."), price: "R$ 40", tags: [] },
        { name: "Piña Colada", desc: d("Abacaxi, coco, groselha e leite condensado.", "Pineapple, coconut, grenadine and condensed milk.", "Piña, coco, granadina y leche condensada."), price: "R$ 40", tags: [] },
      ],
    },
    {
      group: "doses",
      items: [
        { name: "Gin Tônica e Frutas", desc: null, price: "R$ 45", tags: [] },
        { name: "Gin Tônica, Frutas Vermelhas e Red Bull", desc: null, price: "R$ 50", tags: [] },
        { name: "Smirnoff Ice", desc: null, price: "R$ 15", tags: [] },
        { name: "Dose de Vodka", desc: null, price: "R$ 20", tags: [] },
        { name: "Dose de Pinga", desc: null, price: "R$ 20", tags: [] },
        { name: "Dose de Ypioca", desc: null, price: "R$ 10", tags: [] },
        { name: "Dose de Sagatiba", desc: null, price: "R$ 10", tags: [] },
        { name: "Dose de Bacardi", desc: null, price: "R$ 10", tags: [] },
        { name: "Dose de Conhaque", desc: null, price: "R$ 15", tags: [] },
        { name: "Dose de Campari", desc: null, price: "R$ 20", tags: [] },
        { name: "Dose de Malibu", desc: null, price: "R$ 20", tags: [] },
        { name: "Dose de Absolut", desc: null, price: "R$ 35", tags: [] },
        { name: "Dose de Whisky (Red Label)", desc: null, price: "R$ 40", tags: [] },
      ],
    },
  ],
  bebidas: [
    {
      group: "cervejas",
      items: [
        { name: "Original (lata)", desc: null, price: "R$ 9", tags: [] },
        { name: "Heineken (lata)", desc: null, price: "R$ 10", tags: [] },
        { name: "Heineken Zero (lata)", desc: null, price: "R$ 10", tags: [] },
        { name: "Original (garrafa)", desc: null, price: "R$ 26", tags: [] },
        { name: "Heineken (garrafa)", desc: null, price: "R$ 26", tags: [] },
        { name: "Heineken (long neck)", desc: null, price: "R$ 16", tags: [] },
        { name: "Heineken Zero (long neck)", desc: null, price: "R$ 16", tags: [] },
        { name: "Budweiser (long neck)", desc: null, price: "R$ 15", tags: [] },
        { name: "Corona (long neck)", desc: null, price: "R$ 15", tags: [] },
      ],
    },
    {
      group: "sucos",
      items: [
        { name: "Abacaxi com Hortelã", desc: null, price: "R$ 19", tags: [] },
        { name: "Laranja com outras Frutas", desc: null, price: "R$ 21", tags: [] },
        { name: "Suco Rainha do Mar", desc: d("Abacaxi, coco, morango e leite condensado.", "Pineapple, coconut, strawberry and condensed milk.", "Piña, coco, fresa y leche condensada."), price: "R$ 24", tags: ["house"] },
        { name: "Suco 7 Fontes", desc: d("Abacaxi, coco e leite condensado.", "Pineapple, coconut and condensed milk.", "Piña, coco y leche condensada."), price: "R$ 23", tags: [] },
        { name: "Mix de Frutas", desc: d("Caju, maracujá, morango e abacaxi.", "Cashew fruit, passion fruit, strawberry and pineapple.", "Cajú, maracuyá, fresa y piña."), price: "R$ 25", tags: [] },
        { name: "Frutas Vermelhas", desc: null, price: "R$ 25", tags: [] },
        { name: "Coco", desc: null, price: "R$ 23", tags: [] },
        { name: "Açaí", desc: null, price: "R$ 25", tags: [] },
        { name: "Banana", desc: null, price: "R$ 23", tags: [] },
        { name: "Limão / Laranja / Morango / Acerola / Kiwi", desc: null, price: "R$ 18", tags: [] },
        { name: "Maracujá / Caju", desc: null, price: "R$ 24", tags: [] },
      ],
    },
    {
      group: "bebidasGelo",
      items: [
        { name: "Coca-Cola", desc: null, price: "R$ 8", tags: [] },
        { name: "Outros Refrigerantes", desc: null, price: "R$ 7", tags: [] },
        { name: "Água Tônica", desc: null, price: "R$ 7", tags: [] },
        { name: "Água sem Gás", desc: null, price: "R$ 6", tags: [] },
        { name: "Água com Gás", desc: null, price: "R$ 8", tags: [] },
        { name: "H2O", desc: null, price: "R$ 15", tags: [] },
        { name: "Energético", desc: null, price: "R$ 16", tags: [] },
        { name: "Copo de Gelo com Limão", desc: null, price: "R$ 3", tags: [] },
        { name: "Saco de Gelo (5kg)", desc: null, price: "R$ 50", tags: [] },
      ],
    },
  ],
  extras: [
    {
      group: "saladas",
      items: [
        { name: "Simples", desc: d("Alface, tomate e cebola.", "Lettuce, tomato and onion.", "Lechuga, tomate y cebolla."), price: "R$ 40", tags: [] },
        { name: "Mista", desc: d("Alface, tomate, cenoura e azeitonas.", "Lettuce, tomato, carrot and olives.", "Lechuga, tomate, zanahoria y aceitunas."), price: "R$ 50", tags: [] },
        { name: "Mista com Palmito", desc: null, price: "R$ 65", tags: [] },
      ],
    },
    {
      group: "extras",
      items: [
        { name: "Arroz", desc: null, price: "R$ 40", tags: [] },
        { name: "Feijão", desc: null, price: "R$ 40", tags: [] },
        { name: "Farofa de Banana", desc: null, price: "R$ 50", tags: [] },
        { name: "Vinagrete", desc: null, price: "R$ 30", tags: [] },
        { name: "Porção de Pão", desc: null, price: "R$ 18", tags: [] },
        { name: "Pirão", desc: null, price: "R$ 50", tags: [] },
        { name: "Molho Rosé", desc: null, price: "R$ 3", tags: [] },
      ],
    },
    {
      group: "sobremesas",
      items: [
        { name: "Sorvetes", desc: null, price: "R$ 16", tags: [] },
        { name: "Petit Gateau", desc: null, price: "R$ 30", tags: [] },
        { name: "Açaí Completo", desc: null, price: "R$ 30", tags: [] },
      ],
    },
  ],
};

const LEGACY_BARCA_DESCRIPTION = "Filé de sororoca grelhado com molho de lula especial, arroz, salada mista com palmito e manga ou fritas.";
const CURRENT_BARCA_DESCRIPTION = d(
  "Filé de peixe grelhado (sororoca) com molho especial de lula. Acompanha arroz e salada mista com palmito e manga ou batatas fritas.",
  "Grilled sororoca fish fillet with special squid sauce. Served with rice and mixed salad with hearts of palm and mango, or fries.",
  "Filete de pescado a la parrilla (sororoca) con salsa especial de calamar. Acompañado de arroz y ensalada mixta con palmito y mango, o papas fritas."
);

// Preserve owner-edited menu entries while correcting previously saved legacy text.
export function normalizeLegacyBarcaDoReiMenu(menu) {
  if (!Array.isArray(menu?.pratos)) return menu;
  let updated = false;
  const pratos = menu.pratos.map(group => ({
    ...group,
    items: (group.items || []).map(item => {
      if (item.name === "Barca do Rei" && item.desc?.pt === LEGACY_BARCA_DESCRIPTION) {
        updated = true;
        return { ...item, desc: CURRENT_BARCA_DESCRIPTION };
      }
      return item;
    }),
  }));
  return updated ? { ...menu, pratos } : menu;
}

// Remove a cerveja descontinuada também de cardápios antigos salvos no painel.
// Não altera os outros itens, valores ou categorias.
export function removeImperioFromMenu(menu) {
  if (!Array.isArray(menu?.bebidas)) return menu;
  let changed = false;
  const bebidas = menu.bebidas.map(group => {
    if (!Array.isArray(group.items)) return group;
    const items = group.items.filter(item => {
      const name = String(item?.name || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      const isImperio = name === "imperio" || name.startsWith("imperio (");
      if (isImperio) changed = true;
      return !isImperio;
    });
    return items.length === group.items.length ? group : { ...group, items };
  });
  return changed ? { ...menu, bebidas } : menu;
}
